// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import CorePage from './CorePage';
import DataDisplayPage from './DataDisplayPage';
import FeedbackPage from './FeedbackPage';
import InputsPage from './InputsPage';
import NavigationPage from './NavigationPage';
import OverlaysPage from './OverlaysPage';
import LayoutPage from './LayoutPage';
import AlertsPage from './AlertsPage';

export default function UIRoutes() {
  return (
    <Routes>
      <Route path="core" element={<CorePage />} />
      <Route path="data-display" element={<DataDisplayPage />} />
      <Route path="feedback" element={<FeedbackPage />} />
      <Route path="alerts" element={<AlertsPage />} />
      <Route path="inputs" element={<InputsPage />} />
      <Route path="navigation" element={<NavigationPage />} />
      <Route path="overlays" element={<OverlaysPage />} />
      <Route path="layout" element={<LayoutPage />} />
    </Routes>
  );
}
